import React from 'react'

const HistoryViewButton = () => {
    return (
        <>
            <button className="py-1.5 px-3 text-[#fff] text-sm bg-[#1751D0] rounded-md font-interMedium">View</button>
        </>
    )
}

export default HistoryViewButton